const addDecimals = (num) => {
    return(Math.round(num*100)/100).toFixed(2);
};


export const updateCart = (state) => {


    // Calculate items price
    if(state.cartItems.length>0){
        // İndirimli fiyat HER ZAMAN price - (price * discount / 100) formülüyle hesaplanır
        // (Product.jsx'teki ürün kartlarında kullanılan formülle birebir aynı). Sepetten
        // placeorder'a, oradan da nihai satılan tutara kadar tek ve tutarlı bu formül geçerli.
        state.itemsPrice = addDecimals(state.cartItems.reduce((acc,item) =>acc + (item.price - (item.price*item.discount/100))*item.qty,0));
}
    // Calculate shipping price
   // state.shippingPrice=  addDecimals(state.itemsPrice > 100 ? 0 : 10);
    // Calculate tax price
    state.taxPrice = addDecimals(Number((0.20*state.itemsPrice).toFixed(2)));
    // Calculate total price
    state.totalPrice = (
        Number(state.itemsPrice) +
     //   Number(state.shippingPrice) + 
        Number(state.taxPrice)
    ).toFixed(2);
    
   
    localStorage.setItem('cart',JSON.stringify(state));
    return state;
}